export default __webpack_public_path__ + "static/media/service-erp.f18d5b04.png";